export default __webpack_public_path__ + "static/media/14.fad683a9.png";